module.exports = __webpack_public_path__ + "img/relacionescolor-nucleodediagnostico.dc341db6.png";